import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=ad986536&scoped=true&"
import script from "./friends.vue?vue&type=script&lang=js&"
export * from "./friends.vue?vue&type=script&lang=js&"
import style0 from "./friends.vue?vue&type=style&index=0&id=ad986536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad986536",
  null
  
)

export default component.exports